// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// index.js or main.js
import 'vuetify/dist/vuetify.min.css'; // Ensure you are using css-loader
import Vue from 'vue';
import Vuetify from 'vuetify';
import App from './App';
import router from './router';
import { store } from './store';
import VS2 from 'vue-script2';

Vue.use(Vuetify);

Vue.use(VS2);

Vue.config.productionTip = false;

/* eslint-disable no-new */
window.vueapp = new Vue({
  el: '#app',
  data: { isApp: false },
  methods: {
    toggleApp() {
      //console.log('test');
      //vueapp.$root.$children[0].auth.setSession({accessToken:"",idToken: "", expiresIn:"" });
      //
      this.$store.dispatch('setIsApp', true);
      this.isApp = true;
      return this.isApp;
    }
  },
  router,
  store,
  components: { App },
  template: '<App />'
});



// WEBPACK FOOTER //
// ./src/main.js